import axios from "axios";
import { QueryParameters } from "types/QueryParameters";

export interface PaymentEntry {
  date: string;
  reference: string;
  type: string;
  customer_name: string;
  amount: string;
  entry_id: number;
  returned_entry_ids: number[];
}

interface PaymentData {
  data: PaymentEntry[];
}
interface SummaryData {
  data: {
    count: number;
  };
}

export const getCommercialDocumentsEntries = async ({
  page = 0,
  filters = {},
}: QueryParameters) => {
  const { data } = await axios.get<PaymentData>(
    "/tenant/commercial_document/entries.json",
    {
      params: {
        page,
        ...filters,
      },
    }
  );
  return { data: data.data };
};

export const getCommercialDocumentsSummary = async ({
  filters = {},
}: QueryParameters) => {
  const { data } = await axios.get<SummaryData>(
    "/tenant/commercial_document/entries/count.json",
    {
      params: {
        ...filters,
      },
    }
  );
  return { data: data.data };
};

export const getCommercialDocumentsPDFs = async ({
  entry_id,
}: {
  entry_id: string;
}) => {
  const { data } = await axios.get<PaymentData>(
    "/tenant/reports/journal_reports/print_entry",
    {
      params: {
        entry_id,
      },
    }
  );
  return { data: data.data };
};

export type GetPaidBannerStatus = "pending" | "accepted" | "rejected";

export const getPaidBannerDetails = async () => {
  const { data } = await axios.get<{
    get_paid_status: GetPaidBannerStatus | null;
    rejection_reason: string;
    banner_dismiss_status: boolean;
    is_get_paid_enabled: boolean;
  }>("/tenant/invoices/get_paid_banner_status");
  return data;
};

export const patchPaidBannerDismissStatus = async () => {
  await axios.patch<void>("/tenant/tenant_users/update_get_paid_banner_display");
};

export const getTahseelBannerDetails = async () => {
  const { data } = await axios.get<{
    tahseel_status: "active" | null;
    banner_dismiss_status: boolean;
    is_get_paid_enabled: boolean;
  }>("/tenant/invoices/tahseel_banner_status");
  return data;
};

export const patchTahseelBannerDismissStatus = async () => {
  await axios.patch<void>("/tenant/tenant_users/update_tahseel_banner_display");
};
